import React from 'react'

import type { BlueprintDocument } from '@/grove-blueprints/generated-types'

import { BlueprintBindingsContext } from './__internal__/utils/blueprint-bindings-context'
import { RenderGroveBlueprintNode } from './__internal__/utils/render-grove-blueprint-node'
import type { BlueprintBindings } from './blueprint-bindings'

export function RenderGroveBlueprintContent({
  bindingHandlers,
  bindingValues,
  content,
}: {
  readonly bindingHandlers?: BlueprintBindings['bindingHandlers']
  readonly bindingValues?: BlueprintBindings['bindingValues']
  readonly content: BlueprintDocument
}) {
  return (
    <BlueprintBindingsContext.Provider
      value={{
        bindingValues: bindingValues ?? {},
        bindingHandlers: bindingHandlers ?? {},
      }}
    >
      <RenderGroveBlueprintNode node={content.root} />
    </BlueprintBindingsContext.Provider>
  )
}
